import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './base.css';
import './index.css';

/**
 * Version of AWOS for desktop and mobile
 */
ReactDOM.render((
    <App pollInterval="60000"/>
  ), document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/